module.exports = __webpack_public_path__ + "static/media/gear_templateV2.4781d97a.csv";